import { UserAccessService } from 'app/shared/services/user-access.service';
import { ProcessingTotalsFilterService } from 'app/shared/services/processing-totals-filter.service';
import { Component, Input, OnInit } from '@angular/core';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { DashboardWidget } from '../../dashboard-interface';
import { Router } from '@angular/router';

@Component({
	selector: 'app-dashboard-processing-results',
	templateUrl: './dashboard-processing-results.component.html',
	styleUrls: ['./dashboard-processing-results.component.scss'],
	// tslint:disable-next-line: use-host-property-decorator
	host: { 'class': 'col-md-12 col-lg-8' }
})
export class DashboardProcessingResultsComponent extends DashboardWidget implements OnInit {

	private debug = false;
	@Input() title: string;
	@Input() color: string;
	@Input() url: string;
	bindingContext: BindingContext = new BindingContext();
	public rawData: any[];
	private dashboardError = 'Error loading dashboard item, please contact support.';
	private today = new Date().toLocaleString('default', { year: 'numeric', month: 'long', day: 'numeric' });
	permitClick = false;

	constructor(
		private dashboardSvc: DashboardService,
		private router: Router,
		private filterService: ProcessingTotalsFilterService,
		private accessSvc: UserAccessService
	) {
		super();
		this.SetClickThrough();
	}

	ngOnInit() {
		this.getData();
	}

	public navigateWithFilter(defaultFilter: string) {
		if (this.permitClick) {
			if (defaultFilter === 'Total Transactions') {
				defaultFilter = 'Transactions';
			}
			this.filterService.setFilter(defaultFilter);
			this.router.navigate(['/reports/processing-totals/']);
		}
	}

	private getData() {
		this.bindingContext.beginGet();
		this.dashboardSvc.GetProcessingResults().subscribe(
			(resp: any[]) => {
				this.rawData = resp;
				if (this.debug) { console.log(this.rawData); }
				this.bindingContext.endGet();
				resp.forEach(row => {
					if (row.Metric === 'Total Transactions') {
						row.Metric = 'Transactions';
					}
				});
			},
			(response: HttpErrorResponse) => {
				this.bindingContext.endGet();
				this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError, true);
			}
		);
	}

	SetClickThrough() {
		this.accessSvc.GetAccessLevelBySecurableName('|PROCESSING-TOTALS', 'REPORTS', null, null, false).then(resp => {
			if (resp > 0) {
				// They have at least read access
				this.permitClick = true;
			}
		});
	}

}
